import { FormData } from '../types';

export const validateName = (name: string): string | null => {
  if (!name.trim()) {
    return 'Name is required';
  }

  if (name.trim().length < 2) {
    return 'Name must be at least 2 characters';
  }

  return null;
};

export const validatePhone = (phone: string): string | null => {
  if (!phone.trim()) {
    return 'Phone number is required';
  }

  // Ukrainian phone number validation (simple version)
  // Accepts formats: +380XXXXXXXXX, 380XXXXXXXXX, 0XXXXXXXXX
  const phoneRegex = /^(?:\+?38)?0\d{9}$/;

  if (!phoneRegex.test(phone.replace(/\s/g, ''))) {
    return 'Please enter a valid Ukrainian phone number';
  }

  return null;
};

export const validateCity = (city: FormData['city']): string | null => {
  if (!city) {
    return 'Please select a city';
  }

  return null;
};

export const validateWarehouse = (warehouse: FormData['warehouse']): string | null => {
  if (!warehouse) {
    return 'Please select a warehouse';
  }

  return null;
};

export const validateForm = (formData: FormData): Record<string, string | null> => {
  return {
    name: validateName(formData.name),
    phone: validatePhone(formData.phone),
    city: validateCity(formData.city),
    warehouse: validateWarehouse(formData.warehouse),
  };
};

export const isFormValid = (formData: FormData): boolean => {
  const validationResults = validateForm(formData);

  return Object.values(validationResults).every((error) => error === null);
};